export enum AppointmentConstants {
    APPOINTMENT_LIST = 'APPOINTMENT/LIST',
    APPOINTMENT_CURRENT = 'APPOINTMENT/CURRENT',
}
